import { Col, Form, Select } from "antd";
import { UD_NUMBERS_LIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const BgmeaUdAmendmentFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [udNumbers, setUdNumbers] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUdNumbers = async (filter) => {
    setLoading(true);
    const body = {
      page: 1,
      per_page: 10,
      ...(filter?.ud_number && { ud_number: filter.ud_number }),
    };
    const response = await getData(`${UD_NUMBERS_LIST}`, null, body);
    if (response?.status === 200) {
      setUdNumbers(response?.data?.data || []);
    }
    setLoading(false);
  };

  // on search UD numbers
  const onUdNumberSearch = useCallback(async (value) => {
    if (value && value.length >= 2) {
      await getUdNumbers({ ud_number: value });
    } else if (!value) {
      await getUdNumbers();
    }
  }, []);

  useEffect(() => {
    getUdNumbers();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item label="UD Number" name="ud_number">
          <Select
            size="small"
            placeholder="Select UD Number"
            loading={loading}
            showSearch
            optionFilterProp="children"
            onSearch={onUdNumberSearch}
            allowClear
          >
            {udNumbers.map((udNumber) => (
              <Option key={udNumber.id} value={udNumber.id}>
                {udNumber.ud_number}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default BgmeaUdAmendmentFilterFields;
